import { IDocumentValidation } from './../interfaces/document-validation-interface';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-document-verify',
  templateUrl: './document-verify.component.html',
  styleUrls: ['./document-verify.component.scss'],
})
export class DocumentVerifyComponent implements OnInit {
  public documentNumber: FormControl;
  public recaptcha: FormControl;
  @Output()
  documentNumberValidated = new EventEmitter<IDocumentValidation | null>(null);

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.documentNumber = new FormControl('', Validators.required);
    this.recaptcha = new FormControl('', Validators.required);
  }

  public handleFormSubmit(): void {
    if (!this.recaptcha.valid) {
      return;
    }

    this.http
      .post(environment.apiUrl + '/validate_documents', {
        document_number: this.documentNumber.value,
      })
      .subscribe(
        (value: IDocumentValidation) => {
          Swal.fire({
            title: 'Confirma tu identidad',
            text: `¿ Eres ${value.first_name} ${value.last_name} ?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, soy yo',
            cancelButtonText: 'No, me equivoque',
          }).then((result) => {
            if (result.isConfirmed) {
              this.documentNumberValidated.emit(value);
            } else {
              Swal.fire(
                '¿Crees que esto es un error?',
                'Si crees que esto es un error comunicate a la linea fija nacional 7467581',
                'question'
              );
              this.restartForm();
            }
          });
        },
        () => {
          Swal.fire({
            icon: 'error',
            title: 'Ha ocurrido un error',
            text: 'Por favor comunicate a la linea fija nacional 601-7437267 / 333-033-37-42 o al correo electrónico: administrativo@grupoempresarialpyc.com',
            confirmButtonText: 'Entendido',
          });
          this.restartForm();
        }
      );
  }

  private restartForm(): void {
    this.documentNumber = new FormControl('', Validators.required);
    this.recaptcha = new FormControl('', Validators.required);
  }
}
